import { formatDate } from "../../../components/common/helpers";
import { PLAY_URL_ASTIR_BEACH_2, PLAY_URL_ASTIR_BEACH_3 } from "../../../common/playUrls";
import type { ReservationData } from "../../../types/reservation";

export function getReservationDisplayDate(
  data: Pick<ReservationData, "eventDate" | "playUrl" | "customDate" | "customTime"> | null | undefined,
  culture: string,
): string | undefined {
  if (!data?.eventDate) return undefined;

  return formatDate({
    date: data.eventDate,
    culture,
    customDate: data.customDate,
    customTime: data.customTime,
    hideTime: [PLAY_URL_ASTIR_BEACH_2, PLAY_URL_ASTIR_BEACH_3].includes(
      data.playUrl ?? "",
    ),
  });
}
